import { render, staticRenderFns } from "./KgEdgeDialog.vue?vue&type=template&id=02202d17"
import script from "./KgEdgeDialog.vue?vue&type=script&lang=js"
export * from "./KgEdgeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports